import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { PUBLIC } from "./env/client";

const envLabel = PUBLIC.APP_ENV === 'production' ? 'production' : 'staging';
console.log(`[WealthTimeline] v${__APP_VERSION__} · ${envLabel}`);

// Dev-only: clear the ErrorBoundary's stale-chunk reload guard whenever Vite
// performs a full reload (e.g. after dependency re-optimisation). The
// boundary now uses a TTL-based guard so this is only a best-effort cleanup.
if (import.meta.hot) {
  import.meta.hot.on('vite:beforeFullReload', () => {
    try {
      sessionStorage.removeItem('chunk-reload-attempts');
      sessionStorage.removeItem('chunk-reload-attempted');
    } catch {
      // ignore
    }
  });
}

createRoot(document.getElementById("root")!).render(
  <App />
);
